import React, { useState } from 'react';
import './App.css';

export default function StacksWithAlignedBlocks() {
  const [stack1, setStack1] = useState([{}, {}, {}]);
  const [stack2, setStack2] = useState([{}, {}, {}]);
  const [stack3, setStack3] = useState([{}, {}, {}]);
  const [baseBlocks, setBaseBlocks] = useState([{}, {}, {}]);

  const addBlock = (stack, setStack) => {
    if (stack.length < 3) {
      setStack([{}, ...stack]);
    }
  };

  const removeBlock = (stack, setStack) => {
    setStack(stack.slice(1));
  };

  const addBaseBlock = () => {
    if (baseBlocks.length < 3) {
      setBaseBlocks([{}, ...baseBlocks]);
    }
  };

  const removeBaseBlock = () => {
    setBaseBlocks(baseBlocks.slice(0, -1));
  };

  const perspectiveStyle = {
    perspective: '1000px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  };

  const blockStyle = (color, width = 'auto', textColor = 'black') => ({
    background: color,
    margin: '1px',
    padding: '20px 40px',
    borderRadius: '5px',
    width: width,
    textAlign: 'center',
    fontWeight: 'bold',
    color: textColor,
    border: '1px solid #999',
    boxShadow: '4px 4px 10px rgba(0,0,0,0.3)',
    transform: 'rotateX(0deg) rotateY(0deg) translateZ(30px)',
    transformStyle: 'preserve-3d',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  });

  const fullFrameStyle = {
    border: '2px solid #ccc',
    borderRadius: '10px',
    padding: '20px',
    background: '#f9f9f9',
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
    maxWidth: '1000px',
  };

  const stackContainerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: '15px',
    width: '90%',
  };

  const stackStyle = {
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'center',
    width: '26%',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '50px' }}>
      <h1 className="page-heading">Stack'd Leadership</h1>

      <div style={perspectiveStyle}>
        <div style={fullFrameStyle}>
          {/* Base blocks inside full frame */}
          {baseBlocks.map((_, index) => (
            <div key={index} style={blockStyle('black', '90%', 'white')}>
              Emotional Awareness
            </div>
          ))}

          {/* Stacks inside full frame */}
          <div style={stackContainerStyle}>
            <div style={stackStyle}>
              {stack1.map((_, index) => (
                <div key={index} style={blockStyle('#A6A1A1', '100%', 'white')}>Intelligence</div>
              ))}
            </div>

            <div style={stackStyle}>
              {stack2.map((_, index) => (
                <div key={index} style={blockStyle('#14274A', '100%', 'white')}>Communication</div>
              ))}
            </div>

            <div style={stackStyle}>
              {stack3.map((_, index) => (
                <div key={index} style={blockStyle('#C1B45E', '100%', 'white')}>Drive</div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Buttons Section */}
      <div style={{ display: 'flex', gap: '40px', marginTop: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <button
            className="button intelligence-button"
            onClick={() => addBlock(stack1, setStack1)}
          >
            Intelligence +
          </button><br />
          <button
            className="button intelligence-button"
            style={{ marginTop: '10px' }}
            onClick={() => removeBlock(stack1, setStack1)}
          >
            Intelligence -
          </button>
        </div>

        <div style={{ textAlign: 'center' }}>
          <button
            className="button communication-button"
            onClick={() => addBlock(stack2, setStack2)}
          >
            Communication +
          </button><br />
          <button
            className="button communication-button"
            style={{ marginTop: '10px' }}
            onClick={() => removeBlock(stack2, setStack2)}
          >
            Communication -
          </button>
        </div>

        <div style={{ textAlign: 'center' }}>
          <button
            className="button drive-button"
            onClick={() => addBlock(stack3, setStack3)}
          >
            Drive +
          </button><br />
          <button
            className="button drive-button"
            style={{ marginTop: '10px' }}
            onClick={() => removeBlock(stack3, setStack3)}
          >
            Drive -
          </button>
        </div>

        <div style={{ textAlign: 'center' }}>
          <button
            className="button base-button"
            onClick={addBaseBlock}
          >
            Emotional Awareness +
          </button><br />
          <button
            className="button base-button"
            style={{ marginTop: '10px' }}
            onClick={removeBaseBlock}
          >
            Emotional Awareness -
          </button>
        </div>
      </div>
    </div>
  );
}